import React, { Component } from 'react';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import {Button} from 'rmwc/Button';
import { Snackbar } from 'rmwc/Snackbar';
import { Typography } from 'rmwc/Typography';
import { Select } from 'rmwc/Select';
import { Link } from 'react-router-dom'
import { Card, CardAction } from 'rmwc/Card';
import { TextField} from 'rmwc/TextField';
import { List, SimpleListItem, CollapsibleList} from 'rmwc/List';
import * as api from '../../api/api';
import StatusMessage from '../../util/StatusMessage'


class MyPurchaseOrders extends Component {

  constructor(props){
    super(props);
    this.state={
      errorMsg: '',
      data: {
        orderedItems: [],
      },
    }
  }

  componentDidMount() {
    let data = Object.assign({}, this.state.data)
    api.getCartDetails(this.props.user.accessToken)
      .then((result) => {
        //console.log(result)
        if(result.status === 'success'){
          data.orderedItems = result.data
          this.setState({data: data})
        }
        else {
          this.setState({errorMsg: 'Error in fetching the data, Please contact Admin'})
        }
      })
  }

  handlePay = (e, paymentId) => {
    e.preventDefault();
    api.handlePurchasePay(this.props.user.accessToken, paymentId)
    .then((result) => {
      if(result.status === "success") {
        if (result.redirect_to) {
          window.location.href = result.redirect_to;
        }
      }
      else {
          this.setState({errorMsg: result.message})
      }
    })
  }

  handleInvoice = (e, paymentId) => {

    e.preventDefault()
    let payId = paymentId + ".pdf" 

    api.downloadTPOInvoice(this.props.user.accessToken, payId)
      .then((result) => {
        if (result instanceof Blob) {
          const url = window.URL.createObjectURL(result);
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'invoice.pdf');
          document.body.appendChild(link);
          link.click();
        }
        else{
          this.setState({errorMsg: 'Unable to download invoice. Please contact Administrator' })
          
        }  
    })
  }

  render() {
    let orderedItems = this.state.data.orderedItems
    let handlePay = this.handlePay
    let handleInvoice = this.handleInvoice
    let displayComponent;
    let moreDetailsComponent, finalAmountComponent;
    if(orderedItems.length === 0){
      displayComponent = (<Card style={{marginBottom: '10px', paddingLeft:'10px'}}>
          <p> There are no active purchases </p>
        </Card>
        )
    }
    else{
    displayComponent = (
      <div>
        {orderedItems.map(function(items) {
          let payButtonComponent;
          if(items.payment_status === 'Pending' || items.payment_status === 'Failed'){
            payButtonComponent = (<Button onClick={((e) => handlePay(e, items.payment_id))}>Pay</Button>)
          }
          else if(items.payment_status === 'Credit'){
            payButtonComponent = (<Button onClick={((e) => handleInvoice(e, items.payment_id))}>Invoice</Button>)
          }

          if(items.payment_status === 'Credit'){
            moreDetailsComponent = <OrderedItemsList orderedItemList={items.payment_item_details} payButton = {payButtonComponent} discountAmount={items.payment_discount} cartAmount={items.payment_final_amount}/>
            finalAmountComponent = (<GridCell span="4">Cart Amount: {items.payment_amount}</GridCell>)
          }
          else{
            moreDetailsComponent = <OrderedItemsList orderedItemList={items.cart_item_details} payButton = {payButtonComponent} discountAmount={items.cart_discount} cartAmount={items.cart_final_amount}/>
            finalAmountComponent = (<GridCell span="4">Cart Amount: {items.cart_amount}</GridCell>)
          }

          return(
            <div style={{paddingLeft:'10px'}}>
              <Typography use="subtitle"> <b>Details for your purchase on: {items.created_at}</b></Typography><br/>
            <Card key={Math.random()} style={{marginBottom: '10px', paddingLeft:'10px'}}>
              <div>
                <Grid>
                  {finalAmountComponent}
                  
                  <GridCell span="4">
                  </GridCell>
                  
                  <GridCell span="4">
                    Payment status: {items.payment_status}
                  </GridCell>
                </Grid>
              </div>
              {moreDetailsComponent}
            </Card> </div>
          )
        })}
      </div>
    )
    }

    return(
      <div hidden>
        <Grid>
          <GridCell span="12">
            <Typography use="headline6">My Orders</Typography>
          </GridCell>
        </Grid>
        {displayComponent}
        <StatusMessage error_msg = {this.state.errorMsg} />
      </div>
      );
  }
 }

 class OrderedItemsList extends Component {

  constructor(props) {
    super(props);
    this.state = {
      expand: false,
      showMoreDetails: false,
    }
  }

  handleMoreDetails = (expand, showMoreDetails) => {
    this.setState({expand: expand, showMoreDetails: showMoreDetails})
  }


  render()  {
    let orderedList = this.props.orderedItemList
    let handleMoreDetails = this.handleMoreDetails
    let displayComponent, detailButtonComponent;

    if(this.state.showMoreDetails){
      displayComponent = (
        <div>
          <Grid>
            <GridCell span="6">Final Amount: {this.props.cartAmount}</GridCell>
            <GridCell span="6">Discount Amount: {this.props.discountAmount}</GridCell>
          </Grid>
          {orderedList.map((item) => (
            <Grid key={Math.random()}>
              <GridCell span="6">{item.name}</GridCell>
              <GridCell span="6">{item.amount}</GridCell>
            </Grid>
          ))}
        </div>
      )
    }

    if(this.state.expand === false)
      detailButtonComponent = (
        <Grid>
          <GridCell span="8">{this.props.payButton}</GridCell>
          <GridCell span="4" ><Button onClick={() => handleMoreDetails(true,true)}  style={{width: '50%'}}>More Details</Button></GridCell>
        </Grid>
      )
    else {
      detailButtonComponent = (
        <Grid>
          <GridCell span="8">{this.props.payButton}</GridCell>
          <GridCell span="4"><Button onClick={() => handleMoreDetails(false,false)}  style={{width: '50%'}}>Less Details</Button></GridCell>
        </Grid>
      )
    }

    return(
      <div hidden>
        {displayComponent}
        {detailButtonComponent}
      </div>
    );
  }
 }

 function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(MyPurchaseOrders);


// WEBPACK FOOTER //
// ./src/views/purchases/MyPurchaseOrders.jsx